'use client'

import useNextRouter from '@/hooks/useNextRouter';
import useSetSearchParams from '@/hooks/useSetSearchParams';
import getNextDate from '@/utils/getNextDay';
import { ButtonHTMLAttributes, ReactNode, useState } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    city: string;
    country?: string;
    checkIn?: string,
    checkOut?: string,
    passenger?: string,
    children: ReactNode,
    lat?: string,
    lng?: string;
    isSmartButton?: boolean
}

export default function NavigateToSearchPage({ isSmartButton = false, city, country, checkIn, checkOut, passenger = 'a1_c-1', children, ...props }: Props) {
    const [isLoading, setIsLoading] = useState(false)
    const { params: { checkIn: checkInParam, checkOut: checkOutParam } } = useSetSearchParams()
    const internalCheckIn = checkIn || checkInParam || getNextDate(0)
    const internalCheckOut = checkOut || checkOutParam || getNextDate(1)

    const router = useNextRouter()

    const handleNavigation = () => {
        const isExternalReferrer = !!document.referrer && (new URL(document.referrer).origin !== window.location.origin);

        if (isExternalReferrer || !isSmartButton) {
            // Redirect to the custom page passed as a prop
            router.push(city ?
                `/hotels/${country ? `${country}/` : ''}${city}?std=${internalCheckIn}&end=${internalCheckOut}&passenger=${passenger}`
                :
                `/hotels/search`)
        } else {
            // Navigate to the previous page within the app
            router.back();
        }
    };

    return (
        <button
            disabled={isLoading}
            onClick={handleNavigation}
            aria-label={typeof children === 'string' ? children : 'Navigate to search page'}
            {...props}
        >
            {children}
        </button>
    );
}